<div
  class="listbox-select"
  (click)="togglePopover(panel, $event)"
>
  @if (activeSelection()) {
    <span class="listbox-select__active-marker"></span>
  }

  <span class="listbox-select__label">
    @if (listBoxValue()) {
      {{ selectedOption()[optionLabel()] ?? placeholder() }}
    } @else {
      {{ placeholder() }}
    }
  </span>

  <svg
    icon="arrows"
    class="listbox-select__icon"
  />
</div>

<p-popover
  #panel
  appendTo="body"
>
  <div class="listbox-select__panel">
    @if (canCheckAll()) {
      <div class="listbox-select__additional-field listbox-select__additional-field_all">
        <div
          class="listbox-select__item"
          (click)="selectAllOption(panel)"
        >
          <span>
            {{ allOption()[optionLabel()] }}
          </span>

          @if (listBoxValue() === allOptionValue()) {
            <svg
              icon="check"
              class="listbox-select__checkmark"
            />
          }
        </div>
      </div>
    }

    <p-list-box
      #pListBox
      class="listbox-select__list"
      [options]="options()"
      [optionLabel]="optionLabel()"
      [optionValue]="optionValue()"
      [emptyMessage]="emptyMessage()"
      [(ngModel)]="listBoxValue"
      (onChange)="onChange(panel, $event)"
    >
      <ng-template
        let-option
        let-selected="selected"
        pTemplate="item"
      >
        <div class="listbox-select__item">
          <span>{{ option[optionLabel()] }}</span>

          @if (selected) {
            <svg
              icon="check"
              class="listbox-select__checkmark"
            />
          }
        </div>
      </ng-template>
    </p-list-box>

    <div
      class="listbox-select__additional-field listbox-select__additional-field_footer"
      (click)="emitFooterClick(panel)"
    >
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</p-popover>
